/* global G */

import { setKey } from 'lib/util'

/**
 * Clean Action Hook
 *
 * Clears the dirty (G.UNDO) state from the current action.
 *
 * @param {Gaia.AppModule.Spec} obj  the current module composition object
 * @returns {function(...[*]): Promise<*[]>}
 */
export default obj => async (...args) => {
  try {
    const moduleState = obj[G.STATE][G.ACTION][G.STATE]
    setKey(null, G.UNDO, moduleState)
  } catch (e) {
    console.error(e)
  }
  return args
}
